import { defineFcm } from '../shared/factory';

export const FCM_GROWTH_MEMBERSHIP_ROUTING_UPDATE = defineFcm('growth_membership_routing_update')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'monorail',
		context: 'Post Sign Flow (Membership Ask + Share)',
		description: `This configuration enables the Membership Ask + Share experience on the Post-Signature Flow (PSF) for petitions where promotions are turned off.

		This allows us to continue capturing revenue from highly viral petitions that do not conform to our individual petition policy rules.`,
		import: false,
	});
